import React from 'react';
import { Button } from '@cargomatic/ui';
import { Download } from 'lucide-react';
import useSignedUrl from '../../../utils/hooks/useSignedUrl';

/**
 * Button that fetches a signed URL on click and opens it in a new tab.
 *
 * @param {string} documentKey - S3 document key (uses getSignedUrl)
 * @param {string} foreignKey - Entity ID like credit memo _id (uses getSignedUrls)
 * Provide one of documentKey or foreignKey, not both.
 */
const SignedUrlButton = ({
  documentKey,
  foreignKey,
  children,
  ...buttonProps
}) => {
  const { fetchAndOpen, loading } = useSignedUrl();

  const disabled =
    buttonProps.disabled || loading || (!documentKey && !foreignKey);

  return (
    <Button
      variant="ghost"
      size="icon"
      {...buttonProps}
      disabled={disabled}
      onClick={() => fetchAndOpen({ documentKey, foreignKey })}
    >
      {children || <Download className="h-4 w-4" />}
    </Button>
  );
};

export default SignedUrlButton;
